import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import IniciarSesion from "@/views/IniciarSesion.vue";
import UserView from "@/views/UserView.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: IniciarSesion
  },
  {
    path: '/user',
    name: 'user',
    component: UserView
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
